import { getJson } from './http';

export interface StoreContextSnapshot {
  storeId: string;
  storeName: string;
  waitingCount: number;
  onlineDeviceCount: number;
}

export function getStoreContext(storeId: string): Promise<StoreContextSnapshot> {
  return getJson<StoreContextSnapshot>(`/store/${storeId}/context`);
}

export function getWaitingCount(storeId: string): Promise<{ waitingCount: number }> {
  return getJson<{ waitingCount: number }>(`/store/${storeId}/waiting-count`);
}
